import * as React from 'react'
import { ConversationMessageAttachment } from '../../../../../types'
import MessageParagraph from '../MessageParagraph'
import Icon from '../../../../../components/Icons/Icon'
import styled from 'styled-components'

const LinkContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;

  svg {
    width: 16px;
    min-width: 16px;
    height: 18px;
    min-height: 18px;
  }

  a {
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-decoration: underline;
    font-size: 14px;
  }
`

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 10px;
  cursor: zoom-in;

  img {
    display: block;
  }
`

interface IProps {
  message: ConversationMessageAttachment
  onPreviewClick: (url: string) => void
}

const Attachment = (props: IProps) => {
  const { message, onPreviewClick } = props

  const isDisplayable = (contentType: string) => {
    if (!contentType) return false

    const displayableTypes = [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif',
      'image/webp',
      'image/svg+xml'
    ]

    return displayableTypes.includes(contentType.toLowerCase()) ||
      contentType.toLowerCase().startsWith('image/')
  }

  const truncateFilename = (filename: string, maxLength: number = 22): string => {
    if (filename.length <= maxLength) return filename

    const extension = filename.split('.').pop() || ''
    const nameWithoutExtension = filename.substring(0, filename.lastIndexOf('.'))

    if (extension) {
      const availableLength = maxLength - extension.length - 4 // 4 for "..." and "."
      const frontLength = Math.ceil(availableLength / 2)
      const backLength = Math.floor(availableLength / 2)

      return `${nameWithoutExtension.substring(0, frontLength)}...${nameWithoutExtension.substring(nameWithoutExtension.length - backLength)}.${extension}`
    } else {
      // No extension
      const frontLength = Math.ceil((maxLength - 3) / 2) // 3 for "..."
      const backLength = Math.floor((maxLength - 3) / 2)

      return `${filename.substring(0, frontLength)}...${filename.substring(filename.length - backLength)}`
    }
  }

  return (
    <>
      {/* If displayable */}
      {isDisplayable(message.attachment_content_type) && <ImageContainer onClick={() => onPreviewClick(message.attachment_url)}>
        <img src={message.attachment_url} />
      </ImageContainer>}
      {/* If not displayable, show a link */}
      {!isDisplayable(message.attachment_content_type) && <MessageParagraph>
        <LinkContainer>
          <Icon icon='messenger-attachment' />
          <a href={message.attachment_download_url} target="_blank" rel="noopener noreferrer">
            {truncateFilename(message.attachment_file_name)}
          </a>
        </LinkContainer>
      </MessageParagraph>}
    </>
  )
}

export default Attachment